import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { Button } from "@/components/ui/button";
import {
  Form,
  // FormControl,
  // FormField,
  // FormItem,
  // FormLabel,
} from "@/components/ui/form";
// import { Checkbox } from "@/components/ui/checkbox";
import { useEffect } from "react";
import axios from "axios";
import { Selection } from "./ChampVisuelParameter";

export function ModifyTimelineForm({
  patientId,
  setSelection,
  selection,
  selectionRef,
  updateSelection,
  setSelections,
}: {
    patientId: string;
    setSelection: (selection: Selection) => void;
    selection: Selection
    selectionRef: { current: { ZF: string[]; ZP: string[]; ZV: string[] } };
    updateSelection: () => void
    setSelections: React.Dispatch<React.SetStateAction<Selection[]>>;
}) {
  const FormSchema = z.object({
    selection: z.string().optional(),
    isDefault: z.boolean().default(false).optional(),
  });

  const form = useForm<z.infer<typeof FormSchema>>({
    resolver: zodResolver(FormSchema),
  });

  useEffect(() => {
    form.reset({ isDefault: selection?.isDefault });
    }, [selection, form]);

  async function onSubmit(data: z.infer<typeof FormSchema>) {
    updateSelection();
    try {

      const adaptedData = {
        ...data,
        selection: JSON.stringify(selectionRef.current),
      };
      const response = await axios.put(
        `/practitioner/visualfield/${patientId}/${selection.id}/selection`,
        adaptedData
      );
      if (response.data) {
        setSelection(response.data);
        setSelections((selections) =>
          selections.map((s) => (s.id === response.data.id ? response.data : s))
        );
      }
    } catch (error) {
      console.error("Erreur lors de la création de la timeline:", error);
    }
  }

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmit)}
        className="w-full max-w-lg space-y-6"
      >
        {/* <FormField
          control={form.control}
          name="isDefault"
          render={({ field }) => (
            <FormItem className="flex flex-row items-start space-x-3 space-y-0">
              <FormControl>
                <Checkbox
                  checked={field.value}
                  onCheckedChange={field.onChange}
                />
              </FormControl>
              <div className="space-y-1 leading-none">
                <FormLabel>Timeline par défaut</FormLabel>
              </div>
            </FormItem>
          )}
        /> */}
        <Button
          type="submit"
          className="w-full py-2 bg-indigo-500 text-white rounded hover:bg-indigo-600 focus:outline-none"
        >
          Modifier la Timeline
        </Button>
      </form>
    </Form>
  );
}
